import { useCallback } from 'react';
import {
  Option,
  useExchangeSelection,
  variantsForOptions,
} from './exchangeOptions';

export function useOptionAvailability() {
  const [{ selectedProduct, selectedOptions }] = useExchangeSelection();

  return useCallback(
    (option: Option) => {
      if (!selectedProduct) return { available: false, selected: false };

      const hypothetical = { ...selectedOptions, [option.name]: option.value };
      const hasVariant = !!variantsForOptions(selectedProduct, hypothetical)
        .length;

      return {
        available: hasVariant,
        selected: selectedOptions[option.name] === option.value,
      };
    },
    [selectedProduct, selectedOptions],
  );
}
